/**
 * Shadow scale — 4 elevation levels + 2 colored accent shadows.
 * MUI requires a 25-slot shadow array (0..24). We define the 4 levels we use
 * and interpolate the rest.
 */
import type { Shadows } from '@mui/material/styles';

const SHADOW_NONE = 'none';
const SHADOW_1 = '0 1px 2px rgba(20, 33, 61, 0.06), 0 1px 3px rgba(20, 33, 61, 0.04)';
const SHADOW_2 = '0 4px 8px rgba(20, 33, 61, 0.08), 0 2px 4px rgba(20, 33, 61, 0.04)';
const SHADOW_3 = '0 10px 20px rgba(20, 33, 61, 0.10), 0 4px 8px rgba(20, 33, 61, 0.05)';
const SHADOW_4 = '0 20px 40px rgba(20, 33, 61, 0.14), 0 8px 16px rgba(20, 33, 61, 0.06)';

export const lightShadows: Shadows = [
  SHADOW_NONE,
  SHADOW_1,
  SHADOW_2,
  SHADOW_2,
  SHADOW_3,
  SHADOW_3,
  SHADOW_3,
  SHADOW_3,
  SHADOW_4,
  SHADOW_4,
  SHADOW_4,
  SHADOW_4,
  SHADOW_4,
  SHADOW_4,
  SHADOW_4,
  SHADOW_4,
  SHADOW_4,
  SHADOW_4,
  SHADOW_4,
  SHADOW_4,
  SHADOW_4,
  SHADOW_4,
  SHADOW_4,
  SHADOW_4,
  SHADOW_4,
] as Shadows;

const SHADOW_1_DARK = '0 1px 2px rgba(0, 0, 0, 0.30), 0 1px 3px rgba(0, 0, 0, 0.18)';
const SHADOW_2_DARK = '0 4px 8px rgba(0, 0, 0, 0.35), 0 2px 4px rgba(0, 0, 0, 0.20)';
const SHADOW_3_DARK = '0 10px 20px rgba(0, 0, 0, 0.40), 0 4px 8px rgba(0, 0, 0, 0.22)';
const SHADOW_4_DARK = '0 20px 40px rgba(0, 0, 0, 0.50), 0 8px 16px rgba(0, 0, 0, 0.30)';

export const darkShadows: Shadows = [
  SHADOW_NONE,
  SHADOW_1_DARK,
  SHADOW_2_DARK,
  SHADOW_2_DARK,
  SHADOW_3_DARK,
  SHADOW_3_DARK,
  SHADOW_3_DARK,
  SHADOW_3_DARK,
  SHADOW_4_DARK,
  SHADOW_4_DARK,
  SHADOW_4_DARK,
  SHADOW_4_DARK,
  SHADOW_4_DARK,
  SHADOW_4_DARK,
  SHADOW_4_DARK,
  SHADOW_4_DARK,
  SHADOW_4_DARK,
  SHADOW_4_DARK,
  SHADOW_4_DARK,
  SHADOW_4_DARK,
  SHADOW_4_DARK,
  SHADOW_4_DARK,
  SHADOW_4_DARK,
  SHADOW_4_DARK,
  SHADOW_4_DARK,
] as Shadows;

/**
 * Colored accent shadows — for primary CTAs and brand-led elements.
 * Apply via `boxShadow: accentShadows.primary` in component overrides.
 */
export const accentShadows = {
  primary: '0 8px 24px rgba(0, 209, 160, 0.32)',
  primaryHover: '0 12px 32px rgba(0, 209, 160, 0.42)',
  accent: '0 8px 24px rgba(255, 127, 80, 0.32)',
  accentHover: '0 12px 32px rgba(255, 127, 80, 0.42)',
} as const;
